import type {
  ObjectStoreExclusionRuleStoreTypeEnum,
  Configuration,
  ObjectStoreExclusionRule,
} from '@repo/api-gw-sdk';
import {
  ListObjectStoreExclusionRulesApi,
  CreateObjectStoreExclusionRuleApi,
  UpdateObjectStoreExclusionRuleApi,
  DeleteObjectStoreExclusionRuleApi,
  ConditionOperatorEnum,
} from '@repo/api-gw-sdk';
import type { ColumnSort, PaginationState } from '@tanstack/react-table';

import { toJsonText } from '@/components/queryBuilder/QueryLanguageConverter';

import type { HttpClient } from './httpClient';

const baseUrl = '/object-store-exclusion-rules';

export const objectStoreExclusionRules = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listObjectStoreExclusionRulesApi = new ListObjectStoreExclusionRulesApi(
    config
  );
  const createObjectStoreExclusionRuleApi =
    new CreateObjectStoreExclusionRuleApi(config);
  const updateObjectStoreExclusionRuleApi =
    new UpdateObjectStoreExclusionRuleApi(config);
  const deleteObjectStoreExclusionRuleApi =
    new DeleteObjectStoreExclusionRuleApi(config);

  return {
    useList: (
      storeType: ObjectStoreExclusionRuleStoreTypeEnum | null,
      pagination?: PaginationState,
      sorting?: ColumnSort
    ) =>
      httpClient.execute(
        listObjectStoreExclusionRulesApi.listObjectStoreExclusionRules.bind(
          listObjectStoreExclusionRulesApi
        ),
        storeType ? baseUrl : null,
        '',
        currentProjectId,
        pagination?.pageIndex,
        pagination?.pageSize,
        sorting && `${sorting.id}:${sorting.desc ? 'desc' : 'asc'}`,
        storeType
          ? toJsonText({
              operator: ConditionOperatorEnum.In,
              property: 'storeType',
              value: [storeType],
            })
          : undefined
      ),
    create: (rule: ObjectStoreExclusionRule) =>
      createObjectStoreExclusionRuleApi.createObjectStoreExclusionRule(
        currentProjectId,
        rule
      ),
    update: (rule: ObjectStoreExclusionRule) =>
      updateObjectStoreExclusionRuleApi.updateObjectStoreExclusionRule(
        currentProjectId,
        rule.id,
        rule
      ),
    delete: (ruleId: string) =>
      deleteObjectStoreExclusionRuleApi.deleteObjectStoreExclusionRule(
        currentProjectId,
        ruleId
      ),
  };
};
